module.exports = __webpack_public_path__ + "0e8f9e5bd532b98b859c199f69f11c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/hero/app-marketplace-hero_tablet@2x.svg
// module id = 2444
// module chunks = 0